import { type ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

/*
 * EntitySectionLayout (composed, domain-free).
 *
 * The content-column wrapper for an entity detail page's active section body.
 *
 * The deep-linkable sub-section navigation (back link → entity
 * name → section list) no longer renders here as an inline `<aside>`. To match
 * the prototype (`public/js/entity-sub-menu.js`), that sub-nav now renders in
 * the shell SIDE-NAV RAIL, nested under the selected entity — see the composed
 * `RailSubNav` and the `RailSubNav` shell context. The detail route publishes
 * the sub-nav data (sections / active id / entity name / renderLink) upward to
 * the rail; the chrome stays domain-free (the chrome-isolation rule).
 *
 * This layout is therefore a thin, domain-free content wrapper: the feature
 * passes the active section's rendered body as `children`. It is kept as a named
 * composition (rather than folded away) so the entity slices share one content
 * container and a later change to the detail content frame has one home.
 */

export interface EntitySectionLayoutProps {
  /** The active section's rendered body. */
  children: ReactNode;
  className?: string;
}

export function EntitySectionLayout({
  children,
  className,
}: EntitySectionLayoutProps) {
  return (
    <section className={cn('min-w-0 flex-1', className)}>{children}</section>
  );
}
